import { indexItems } from '@/mocks/homeData';

export default function IndexSection() {
  return (
    <section id="index" className="py-16 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center">
          主题索引
        </h2>
        <p className="mt-2 text-sm text-foreground-600 text-center">
          按类型快速浏览 · 找到你想看的电影分类
        </p>

        <div className="mt-10 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-7 gap-3 md:gap-4">
          {indexItems.map((item) => (
            <a
              key={item.id}
              href="#index"
              className="group cursor-pointer rounded-xl bg-background-50 border border-background-200/70 p-5 text-center transition-all hover:border-primary-200 hover:bg-primary-50/50"
            >
              <div className="w-11 h-11 mx-auto rounded-xl bg-primary-100 flex items-center justify-center transition-colors group-hover:bg-primary-200">
                <i className={`${item.icon} text-lg text-primary-600`}></i>
              </div>
              <h3 className="mt-3 text-sm font-semibold text-foreground-900 whitespace-nowrap">
                {item.title}
              </h3>
              <p className="mt-1 text-xs text-foreground-500">{item.count}</p>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}